import React from "react";
import { Navbar as BsNavbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { User, LogOut } from "lucide-react";
import CompanySearch from "./CompanySearch.jsx";

const TOOL_PAGES = ["screens", "alerts", "compare", "portfolio"];

export default function Navbar({
  user,
  page,
  onNavigate,
  onOpenLogin,
  onOpenSignup,
  onLogout,
}) {
  const link = (key, label) => (
    <Nav.Link
      href="#"
      active={page === key}
      onClick={(e) => {
        e.preventDefault();
        onNavigate(key);
      }}
    >
      {label}
    </Nav.Link>
  );

  return (
    <BsNavbar expand="lg" className="app-navbar">
      <Container fluid className="p-0">
        <BsNavbar.Brand
          href="#"
          className="fw-bold me-4"
          onClick={(e) => {
            e.preventDefault();
            onNavigate("home");
          }}
        >
          SpedVest
        </BsNavbar.Brand>

        <BsNavbar.Toggle aria-controls="main-nav" />

        <BsNavbar.Collapse id="main-nav">
          <Nav className="me-auto">
            {link("home", "HOME")}
            {link("feed", "FEED")}
            {link("companies", "COMPANIES")}
            {link("watchlist", "WATCHLIST")}

            <NavDropdown
              title="TOOLS"
              id="tools-dropdown"
              active={TOOL_PAGES.includes(page)}
            >
              <NavDropdown.Item onClick={() => onNavigate("screens")}>
                Screens
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => onNavigate("alerts")}>
                Stock Alerts
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => onNavigate("compare")}>
                Compare Companies
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => onNavigate("portfolio")}>
                Portfolio Tracker
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>

          <CompanySearch className="nav-search" placeholder="Search company or ticker" />

          {user ? (
            <Nav>
              <NavDropdown
                align="end"
                id="user-dropdown"
                className="user-dropdown"
                title={
                  <>
                    <User size={16} /> {user.name.toUpperCase()}
                  </>
                }
              >
                <NavDropdown.Item onClick={onLogout}>
                  <LogOut size={14} className="me-2" />
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          ) : (
            <div className="d-flex align-items-center gap-2 mt-3 mt-lg-0">
              <button className="btn btn-outline-secondary nav-auth-btn" onClick={onOpenLogin}>
                <User size={16} /> LOGIN
              </button>
              <button className="btn btn-purple nav-auth-btn" onClick={onOpenSignup}>
                SIGN UP
              </button>
            </div>
          )}
        </BsNavbar.Collapse>
      </Container>
    </BsNavbar>
  );
}
